import currencyFormatter from "currency-formatter";

const currencyToDecimal = (strInput) => {
  return currencyFormatter.unformat(strInput, { code: "AUD" });
};

export default currencyToDecimal;
